<script setup>
import { reactive } from 'vue'
import { useI18n } from 'vue-i18n'
import _ from 'lodash-es'
import { flattenTree, get,post, validators } from '@/common/util'
import { useMetaStore } from '@/stores'
import 'vue3-tree-vue/dist/style.css'
import Vue3TreeVue from 'vue3-tree-vue'
const i18n=useI18n(),metaStore=useMetaStore()
const meta=reactive({depts:[{name:i18n.t('departmentname'),selected:true,expanded:true,children:[],meta:{isroot:true}}]
  ,acts:[{tk:'initialize',color:''},{tk:'delete',color:'error'},{tk:'modify',color:'info'},{tk:'add',color:'warning'},{tk:'save',color:'primary'}]})
,disableAct=tk=>{
  const isrootsel=meta.seldept.meta.isroot;
  if(tk=='delete'&&isrootsel)return true
  if(tk=='modify'&&isrootsel)return true
  if(tk=='save'&&isrootsel)return true
  return false
},pop=tk=>{
  meta.popto=null
  meta.actkey=tk
  if(tk=='modify'){
    meta.deptnm=meta.seldept.name
  }else if(tk=='delete'){
    meta.actcon='del_con'
  }else if(tk=='initialize'){
    meta.actcon='init_con'
  }else if(tk=='save'){
    meta.actcon='save_con'
  }
  metaStore.pop({ison:true,callback:()=>{
    const act=_.find(meta.acts,{tk:tk})
    meta.popto='#popbody'
  }})
},act=()=>{
  const key=meta.actkey,nm=meta.seldept.name
  if(['add','modify'].includes(key)&&flattenTree(meta.depts).findIndex(node=>node.name==meta.deptnm)>=0)
    return metaStore.toast(i18n.t('nm_already_taken'),false)
  if(key=='add'){
    const ndept={name:meta.deptnm,meta:{parent:meta.seldept},children:[],selected:true,meta:{isroot:false}}
    meta.seldept.selected=false
    meta.seldept.children.push(ndept)
    meta.seldept.expanded=true
    meta.seldept=ndept
  }else if(key=='modify'){
    meta.seldept.name=meta.deptnm
  }else if(key=='delete'){
    const pa=findParentNodeByName(nm)
    if(!pa)return metaStore.toast(i18n.t('cannot_mod_del'))
    deleteNodeByName(nm)
    pa.selected=pa.expanded=true
    meta.seldept=pa
  }else if(key=='save'){
    const depts=flattenTree(meta.depts).filter(node=>!node.meta.isroot).map(node=>({nm:node.name,depth:node.depth,pnm:node.parentNm}))
    post('rest/authed/admin/resetdepts',depts,res=>{
      metaStore.toastKey('thesaveiscomplete')
      init()
    })
  }else if(key=='initialize')init()
  meta.deptnm=''
  metaStore.pop({ison:false})
},deleteNodeByName=nodeName=>{
  const deleteRecursive = (nodes, name) => {
    for (let i = 0; i < nodes.length; i++) {
      if (nodes[i].name === name) {
        nodes.splice(i, 1)
        return true
      }
      if (nodes[i].children) {
        if (deleteRecursive(nodes[i].children, name)) {
          return true
        }
      }
    }
    return false
  }
  deleteRecursive(meta.depts, nodeName)
},findParentNodeByName=nodeName=>{
  return flattenTree(meta.depts).filter(node=>node.children.length>0).find(node=>_.find(node.children,{name:nodeName}))
},onBeforeItemDropped = (dropped,dest) => {
  return new Promise((resolve, _) => {
    resolve(dropped.name!=dest.name&&!dropped.children.map(child=>child.name).includes(dest.name)&&!dest.children.map(child=>child.name).includes(dropped.name))
  })
},init=()=>{
  metaStore.blockLoading()
  get('rest/authed/member/depts',res=>{
    meta.depts=[meta.depts[0]]
    const root=meta.depts[0]
    root.children=[]
    _.orderBy(res.data,'depth','asc').forEach(dept=>{
      const newnode={name:dept.nm,expanded:true,children:[],meta:{isroot:false}}
      if(dept.depth==1)root.children.push(newnode)
      else flattenTree(meta.depts).find(node=>node.name==dept.pnm).children.push(newnode)
    })
    metaStore.blockLoading(false)
    root.selected=true
  })
}
meta.seldept=meta.depts[0]
init()
</script>
<template>
<v-card class="ma-2" flat>
  <v-card-title class="d-flex align-center pe-2">
    <v-container>
      <v-row no-gutters>
        <v-col>{{ $t('man_dept') }}</v-col>
      </v-row>
      <v-row>
        <v-col v-for="act in meta.acts">
          <v-btn block :text="$t(act.tk)" :color="act.color" :disabled="act.tk=='save'?false:disableAct(act.tk)" @click.stop="pop(act.tk)"/>
        </v-col>
      </v-row>
    </v-container>
  </v-card-title>
  <v-divider/>
  <v-card-text>
    <v-container>
      <Vue3TreeVue :items="meta.depts" @onSelect="item=>meta.seldept=item" @dropValidator="onBeforeItemDropped">
         <template #item-prepend-icon="treeViewItem" >
          <v-icon :icon="treeViewItem.meta.isroot?'mdi-account-box-multiple-outline':'mdi-account-multiple'"/>
         </template>
      </Vue3TreeVue>
    </v-container>
  </v-card-text>
</v-card>
<Teleport v-if="meta.popto" :to="meta.popto">
  <v-card class="mx-auto" min-width="340" :title="$t('dept')+' '+$t(meta.actkey)">
  <v-divider/>
  <v-card-text>
    <v-text-field v-if="['add','modify'].includes(meta.actkey)" v-model="meta.deptnm" variant="outlined" :label="$t('departmentname')" :placeholder="$t('pleaseenteradepartmentname')" :rules="[validators.required]"/>
    <div v-else>{{ $t(meta.actcon) }}</div>
  </v-card-text>
  <v-divider/>
  <v-card-actions>
      <v-row justify="end">
        <v-btn :text="$t('cancel')" variant="outlined" @click.stop="meta.deptnm='';metaStore.pop({ison:false})"/>
        <v-btn :text="$t('confirm')" class="ms-2 me-3" variant="elevated" color="primary" @click.stop="act" :disabled="['add','modify'].includes(meta.actkey)&&validators.required(meta.deptnm)!==true"/>
      </v-row>
    </v-card-actions>
  </v-card>
</Teleport>
</template>
